import React from 'react';
import { FormattedMessage } from 'react-intl';

import { HelpButton } from '../../../atoms/help-button';
import { ParentPaper } from '../../../atoms/parent-paper';
import { SliderBox } from '../../../molecules/slider-box';

export const SettingsSpotDistributionPrices = () => {
  return (
    <ParentPaper>
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.price_distribution_low"
              defaultMessage="Cena za distribuci v nízkém tarifu"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.price_distribution_low"
                  defaultMessage="Cena za distribuci v nízkém tarifu"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.price_distribution_low.help"
                  defaultMessage="Cena za distribuci v nízkém tarifu v kč/kWh. Tato cena se přičítá k ceně spotu, pokud je aktivní nízký tarif. Musí být nastaveny časy HDO pro správný výpočet ceny ve vysokém a nízkém tarifu. Tuto částku hledejte ve vyúčtování za elektřinu."
                />
              }
            />
          </>
        }
        variableId="PRICE_DISTRIBUTION_LOW"
        opts={{
          style: 'currency',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }}
        step={{ CZK: 0.01, EUR: 0.01 }}
        min={{ CZK: 0, EUR: 0 }}
        max={{ CZK: 10, EUR: 0.5 }}
      />
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.price_distribution_hi"
              defaultMessage="Cena za distribuci ve vysokém tarifu"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.price_distribution_hi"
                  defaultMessage="Cena za distribuci ve vysokém tarifu"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.price_distribution_hi.help"
                  defaultMessage="Cena za distribuci ve vysokém tarifu v kč/kWh. Tato cena se přičítá k ceně spotu, pokud je aktivní vysoký tarif. Musí být nastaveny časy HDO pro správný výpočet ceny ve vysokém a nízkém tarifu. Tuto částku hledejte ve vyúčtování za elektřinu."
                />
              }
            />
          </>
        }
        variableId="PRICE_DISTRIBUTION_HI"
        opts={{
          style: 'currency',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }}
        step={{ CZK: 0.01, EUR: 0.01 }}
        min={{ CZK: 0, EUR: 0 }}
        max={{ CZK: 10, EUR: 0.5 }}
      />
    </ParentPaper>
  );
};
